import { render } from "./offer.vue?vue&type=template&id=37baf649&scoped=true"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"

import "./offer.vue?vue&type=style&index=0&id=37baf649&scoped=true&lang=css"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37baf649"]])

export default __exports__